import { reduce } from "et3-type-guards";

import configuration from "../../configuration/keys/index";
import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import getCoreUIStore from "../../stores/core/core-ui-store";
import ProfileDropdownButtons from "./ProfileDropdownButtons";
import ET3Div from "../../core/et3-div";
import Et3Text from "../../core/et3-text";
import Et3Image from "../../core/et3-Image";
import ET3Circle from "../../core/et3-circle";
import { HEADER_HEIGHT, HEADER_PADDING_X } from "../header/header-constants";
import {
  PROFILE_AVATAR_SIZE,
  PROFILE_DIVIDER,
  PROFILE_DIVIDER_HEIGHT,
  PROFILE_IDENTITY_GAP,
  PROFILE_LABEL_FONT_SIZE,
  PROFILE_META_GAP,
  PROFILE_META_ROW_HEIGHT,
  PROFILE_NAME_FONT_SIZE,
  PROFILE_PANEL_GAP,
  PROFILE_PANEL_PADDING,
  PROFILE_PANEL_RADIUS,
  PROFILE_PANEL_SHADOW,
  PROFILE_PANEL_WIDTH,
  PROFILE_ROLE_BACKGROUND,
  PROFILE_ROLE_FONT_SIZE,
  PROFILE_ROLE_HEIGHT,
  PROFILE_ROLE_PADDING_X,
  PROFILE_ROLE_RADIUS,
  PROFILE_VALUE_FONT_SIZE
} from "./profile-dropdown-constants";

const PROFILE_DROPDOWN_GUTTER = 8;
const PROFILE_DROPDOWN_TOP = HEADER_HEIGHT + PROFILE_DROPDOWN_GUTTER;
const PROFILE_DROPDOWN_Z_INDEX = 101;

const MetaRow = withLiteObserverAndTheme<{
  label: string;
  value: string;
}>((props) => {
  const { theme, label, value } = props;
  const { colors, unitX, unitY } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="space-between"
      alignItems="center"
      withShadow={false}
      width={0}
      height={PROFILE_META_ROW_HEIGHT}
      color={colors.all.transparent}
      style={{
        width: "100%",
        minWidth: 0,
        height: PROFILE_META_ROW_HEIGHT * unitY,
        gap: PROFILE_IDENTITY_GAP * unitX
      }}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"LIGHT"}
        fontSize={PROFILE_LABEL_FONT_SIZE}
        text={label}
        isSpan={false}
        color={colors.all.davysGrey}
        style={{ margin: 0, textAlign: "left", whiteSpace: "nowrap" }}
      />
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={PROFILE_VALUE_FONT_SIZE}
        text={value}
        isSpan={false}
        color={colors.all.maastrichtBlue}
        style={{ margin: 0, textAlign: "right", whiteSpace: "nowrap" }}
      />
    </ET3Div>
  );
});

const Divider = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { unitY } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={0}
      height={PROFILE_DIVIDER_HEIGHT}
      color={PROFILE_DIVIDER}
      style={{
        width: "100%",
        minWidth: 0,
        height: PROFILE_DIVIDER_HEIGHT * unitY,
        minHeight: PROFILE_DIVIDER_HEIGHT
      }}
      onClick={() => {}}
    />
  );
});

const ProfileDropdown = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX, unitY } = theme;
  const user = getCorePersonalStore().user.get();
  const name = reduce(() => user.fullName, "");
  const role = reduce(() => user.role, "");
  const lastLogin = reduce(() => user.lastLogin, "");
  const userImageName = getCorePersonalStore().userPofilePic.get();

  return getCoreUIStore().isProfileDropdownVisible.get() ? (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="stretch"
      withShadow={false}
      width={PROFILE_PANEL_WIDTH}
      height={0}
      color={colors.all.white}
      style={{
        boxSizing: "border-box",
        position: "absolute",
        right: HEADER_PADDING_X * unitX,
        top: PROFILE_DROPDOWN_TOP * unitY,
        zIndex: PROFILE_DROPDOWN_Z_INDEX,
        borderRadius: PROFILE_PANEL_RADIUS * unitX,
        boxShadow: PROFILE_PANEL_SHADOW,
        padding: PROFILE_PANEL_PADDING * unitX,
        gap: PROFILE_PANEL_GAP * unitY
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="center"
        withShadow={false}
        width={0}
        height={PROFILE_AVATAR_SIZE}
        color={colors.all.transparent}
        style={{
          width: "100%",
          minWidth: 0,
          gap: PROFILE_IDENTITY_GAP * unitX
        }}
        onClick={() => {}}
      >
        <ET3Circle
          withShadow={false}
          size={PROFILE_AVATAR_SIZE}
          color={colors.all.transparent}
          style={{ borderRadius: PROFILE_AVATAR_SIZE * unitX, flexShrink: 0 }}
          onClick={() => {}}
        >
          <Et3Image
            type="LOCAL"
            alt={i18n.get("ALKHATTABA_ADMIN")}
            imageName={userImageName}
            size={PROFILE_AVATAR_SIZE}
            onClick={() => {}}
            style={{}}
          />
        </ET3Circle>
        <ET3Div
          isScrollable={false}
          isExtendable={true}
          fDirection="column"
          justifyContent="center"
          alignItems="flex-start"
          withShadow={false}
          width={0}
          height={0}
          color={colors.all.transparent}
          style={{
            flexGrow: 1,
            minWidth: 0,
            gap: PROFILE_META_GAP * unitY
          }}
          onClick={() => {}}
        >
          <Et3Text
            fontFamily={"BOLD"}
            fontSize={PROFILE_NAME_FONT_SIZE}
            text={name}
            isSpan={false}
            color={colors.all.maastrichtBlue}
            style={{
              margin: 0,
              textAlign: "left",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}
          />
          <ET3Div
            isScrollable={false}
            isExtendable={false}
            fDirection="row"
            justifyContent="center"
            alignItems="center"
            withShadow={false}
            width={0}
            height={PROFILE_ROLE_HEIGHT}
            color={PROFILE_ROLE_BACKGROUND}
            style={{
              boxSizing: "border-box",
              width: "auto",
              minWidth: 0,
              height: PROFILE_ROLE_HEIGHT * unitY,
              borderRadius: PROFILE_ROLE_RADIUS * unitX,
              paddingLeft: PROFILE_ROLE_PADDING_X * unitX,
              paddingRight: PROFILE_ROLE_PADDING_X * unitX
            }}
            onClick={() => {}}
          >
            <Et3Text
              fontFamily={"MEDIUM"}
              fontSize={PROFILE_ROLE_FONT_SIZE}
              text={role}
              isSpan={false}
              color={colors.all.bondiBlue}
              style={{ margin: 0, whiteSpace: "nowrap" }}
            />
          </ET3Div>
        </ET3Div>
      </ET3Div>
      <Divider />
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        fDirection="column"
        justifyContent="center"
        alignItems="stretch"
        withShadow={false}
        width={0}
        height={0}
        color={colors.all.transparent}
        style={{
          width: "100%",
          minWidth: 0,
          gap: PROFILE_META_GAP * unitY
        }}
        onClick={() => {}}
      >
        <MetaRow label={i18n.get("LAST_LOGIN")} value={lastLogin} />
        <MetaRow
          label={i18n.get("DEPLOYED")}
          value={reduce(() => configuration.date, "")}
        />
        <MetaRow
          label={i18n.get("ENVIRONMENT")}
          value={reduce(() => configuration.environment, "")}
        />
        <MetaRow
          label={i18n.get("VERSION")}
          value={reduce(() => configuration.version, "")}
        />
      </ET3Div>
      <Divider />
      <ProfileDropdownButtons />
    </ET3Div>
  ) : null;
});
export default ProfileDropdown;
